import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'are_recruitment_fees_related_costs_paid_workers_line'

export const dataPointDefinition = {
  retracedId: 'are_recruitment_fees_related_costs_paid_workers_line',
  name: 'Are recruitment fees and related costs paid by workers in line with legal requirements?',
  description:
    'The intent of this question is to understand that when workers pay any recruitment fees or related costs, the fees/costs are line with legal requirements (i.e., fee amounts or types of fees).',
  meta: {
    slcpMeta: {
      key: 'fl-4--5',
      number: 'RH-REC-7',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fl-4--5', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27190,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
